import React, { isValidElement } from 'react';
import { useMergeRefs } from '@floating-ui/react';
import { useToggletipContext } from '../../Toggletip';

export const ToggletipTrigger = React.forwardRef<
  HTMLElement,
  React.HTMLProps<HTMLElement> & { asChild?: boolean }
>(function ToggletipTrigger({ children, ...props }, propRef) {
  const context = useToggletipContext();
  const childrenRef = (children as any).ref;
  const ref = useMergeRefs([context.refs.setReference, propRef, childrenRef]);

  if (!isValidElement(children)) {
    throw new Error(
      'Invalid toggletip trigger, please pass a valid element such as a button'
    );
  }

  return React.cloneElement(
    children,
    context.getReferenceProps({
      ref,
      ...props,
      ...children.props,
      'data-state': context.open ? 'open' : 'closed',
    })
  );
});
